import { useEffect } from 'react';

const DOCUMENT_EVENT_NAME_CLICK = 'click';
const DOCUMENT_EVENT_NAME_MOUSEDOWN = 'mousedown';

const useDocumentEvent = ({ eventName, eventHandlerRef, }) => {
    useEffect(() => {
        const onDocEventHandle = (e) => {
            eventHandlerRef.current?.call(document, e);
        };
        document.addEventListener(eventName, onDocEventHandle);
        return () => {
            document.removeEventListener(eventName, onDocEventHandle);
        };
    }, [
        eventName,
        eventHandlerRef,
    ]);
};

export { DOCUMENT_EVENT_NAME_CLICK as D, DOCUMENT_EVENT_NAME_MOUSEDOWN as a, useDocumentEvent as u };
//# sourceMappingURL=hook-D51BbGUy.js.map
